<p-panel styleClass="ioregisters-panel">
  <p-header>
    <div class="ui-helper-clearfix">
      <span class="ui-panel-title" style="display:inline-block">Events Log</span>
      <div class="panel-header-btn-group">
        <p-multiSelect [(ngModel)]="selectedSources" [disabled]="!enableLogging" [displaySelectedLabel]="false"
                       [options]="loggingSources" [showHeader]="false" appendTo="body"
                       defaultLabel="Logging Sources" styleClass="ui-multiselect-small">
        </p-multiSelect>
        <p-toggleButton [(ngModel)]="enableLogging" offLabel="Disabled" onLabel="Enabled"
                        styleClass="ui-button-small"></p-toggleButton>
        <p-button (onClick)="clearLogLines()" label="Clear" styleClass="ui-button-small"></p-button>
      </div>
    </div>
  </p-header>

  <div #logLinesContainer class="list-group events-log-list">
    <div #logLinesItems *ngFor="let i of logLines" [ngClass]="i.style" class="list-group-item source-code event">
      {{i.text}}
    </div>
  </div>
  <div [ngClass]="{'muted': isRunning === true || enableLogging === false}">
  </div>
</p-panel>
